import { createAction, props } from '@ngrx/store';
import type { SavePageViewRequest } from '../../models/save-page-view-request.interface';

export const savePageView = createAction('[Analysis] save page view', props<{ payload: SavePageViewRequest }>());
